import { requireField } from './validators';

export default class IncidentDocument {
  constructor(data = {}) {
    requireField(data.name, 'incident.document.name');

    this.id = data.id || `doc-${Math.random().toString(36).slice(2, 9)}`;
    this.name = data.name;
    this.uploadedAt = data.uploadedAt || new Date().toISOString();
    this.uploadedBy = data.uploadedBy || 'System';
  }

  toJSON() {
    return { ...this };
  }
}
